import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Admission() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Admission</strong></p>
              <div className="clear"></div>
            </span>
            <div id="facil">
              <div style={{ textAlign: 'left' }}></div>
              <p style={{ textAlign: 'left' }}><span style={{ color: '#990000', fontWeight: 'bold', fontSize: '10pt' }}><strong>We offer 3 years Diploma Courses for the below Departments</strong></span></p>
              <p style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}></p>
              <table width="373" border="0" align="center" cellPadding="0" cellSpacing="0" style={{ border: '1px solid #eeeeee' }}>
                <tbody>
                  <tr>
                    <td height="30" bgcolor="#EBEBEB"><p><strong>Computer Science &amp; Engineering</strong></p></td>
                    <td height="30" bgcolor="#EBEBEB"><p style={{ textAlign: 'center' }}><strong>27</strong></p></td>
                  </tr>
                  <tr>
                    <td width="286" height="30" bgcolor="#EBEBEB"><p><strong>Electronics &amp; Communication Engineering</strong></p></td>
                    <td width="87" height="30" bgcolor="#EBEBEB"><p style={{ textAlign: 'center' }}><strong>27</strong></p></td>
                  </tr>
                  <tr>
                    <td height="30" bgcolor="#EBEBEB"><p><strong>Mechanical Engineering </strong></p></td>
                    <td height="30" bgcolor="#EBEBEB"><p style={{ textAlign: 'center' }}><strong>27</strong></p></td>
                  </tr>
                  <tr>
                    <td width="286" height="30" bgcolor="#EBEBEB"><p><strong>Apparel Design &amp; Fabrication Technology </strong></p></td>
                    <td width="87" height="30" bgcolor="#EBEBEB"><p style={{ textAlign: 'center' }}><strong>27</strong></p></td>
                  </tr>
                </tbody>
              </table>
              <p style={{ color: '#990000', fontWeight: 'bold', fontSize: '10pt' }}><strong>Eligibility</strong></p>
              <ul>
                <li>SSLC or Equivalent</li>
                <li>Candidates should have studied in Karnataka for at least 5 years or else eligibility certificate is to be obtained from DTE, Bangalore.</li>
              </ul>
              <p><strong>For ITI Holders &amp; PUC (Science) Passed Students admission is made directly to&nbsp;the Second year under the Lateral Entry Scheme. </strong></p>
              <p style={{ textAlign: 'left', color: '#990000', fontWeight: 'bold', fontSize: '10pt' }}><strong>Eligibility for Admission to First Year:</strong></p>
              <p style={{ textAlign: 'left' }}><strong>For Karnataka Students:</strong></p>
              <ul>
                <li>Minimum Qualification is a <strong>Pass</strong> in 10th Standard (SSLC) or equivalent examination with a total of <strong>70</strong> marks in Science and Mathematics.</li>
                <li>PUC Pass/Fail students can also apply.</li>
                <li>Category I, IIA, IIB, IIIA, IIIB are applicable only for Karnataka Students.</li>
              </ul>
              <p><strong>For Non-Karnataka &amp; CBSE Students:</strong></p>
              <ul>
                <li>Students who have studied outside Karnataka and CBSE students will have to obtain <strong>Eligibility Certificate</strong> from the Secretary, Board of Technical Examination, Palace Road, Bangalore before gaining admission to the Polytechnic.</li>
              </ul>
              <p><strong>Note : For ITI Holders &amp; PUC (Science) Passed Students admission is made directly to the Second year under the Lateral Entry Scheme.</strong></p>
              <p style={{ color: '#990000', fontWeight: 'bold', fontSize: '10pt' }}><strong>Selection:</strong></p>
              <ul>
                <li>The selection is on merit and first come first serve basis.</li>
                <li>The list of provisional selected students will be notified on the notice board of the institution.</li>
                <li>Provisional admission is given after payment of prescribed fee and submissions of all required documents within the stipulated date.</li>
              </ul>
              <p style={{ color: '#990000', fontWeight: 'bold', fontSize: '10pt' }}><strong>Note:</strong></p>
              <ul>
                <li>The Admission Rules &amp; guidelines issued by the Government of Karnataka at the time of admission, will be final &amp; applicable including reservation norms for different categories.</li>
                <li> Provisional admission shall be approved by <strong>Directorate of Technical Education</strong> (<a href="http://dtek.karnataka.gov.in/" target="_blank" rel="noopener noreferrer" className="inlinks">DTE</a>), Bengaluru. </li>
                <li>Detailed instructions are issued with the application forms for admission.</li>
              </ul>
              <p><strong style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>Note:</strong><br />
                <br />
                For fee structure details under management quota seats, candidates are requested to contact college office on any working day.</p>
              <p><strong style={{ color: '#993333', fontWeight: 'bold', fontSize: '10pt' }}>Document Retention Policy: </strong><br />
                <br />
                As per AICTE New Delhi notification dated 25 May 2012, the Polytechnic will not withhold or refuse to return any document deposited with it by a person for the purpose of seeking admission in the event of such person not intending to pursue the same with the Polytechnic.<strong><br />
                </strong> </p>
              <p style={{ color: '#990000', fontWeight: 'bold', fontSize: '10pt' }}>How to Apply:</p>
              <ul>
                <li>Candidates seeking admission to the diploma course should obtain the Prospectus and the Application Form by paying Rs. 300/- in cash at our College office.</li>
                <li>The Prospectus and the Application Form can also be obtained by post by sending a DD (Demand Draft) in favor of The Principal, Indira Shiva Rao Polytechnic, Moodu Perampalli, Udupi for Rs. 350/- payable at Udupi. </li>
              </ul>
              <p>After obtaining the Prospectus and the Application Form, the candidate should fill up the application form with all necessary particulars. The filled-in Application form should be submitted to the College office with the following documents.</p>
              <p>&nbsp;</p>
              <strong><br />
              </strong>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Admission;
